/**
 * Espelha CriarOrdemProducaoOcorrenciaRequest do OrquestradorSuprimentos: anotação do usuário no histórico
 * da ordem de produção. Tipo, origem e usuário são postos pelo servidor.
 */
export class CriarOrdemProducaoOcorrenciaRequest {
  /** Texto do usuário, até 1000 caracteres. */
  descricao: string;
  /** Data do fato, sem futuro; ausente = agora. */
  dataOcorrencia: Date | null = null;
}
